import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import Image from '@/components/base/image';
import { MediaPlainProps } from './media';
import Duration from '../duration';
import { DEFULAT_SHADOW_COVER } from '@/common/constants/default.constant';

const PREFIX = 'MediaPlain';

const classes = {
  wrap: `${PREFIX}-wrap`,
  cover: `${PREFIX}-cover`,
  duration: `${PREFIX}-duration`,
};

const StyledBox = styled(Box)(({ theme: Theme }) => ({
  [`&.${classes.wrap}`]: {
    width: '100%',
    cursor: 'pointer',
  },

  [`& .${classes.cover}`]: {
    position: 'relative',
  },

  [`& .${classes.duration}`]: {
    position: 'absolute',
    left: 10,
    bottom: 10,
  },
}));

export const MediaPlain: React.FC<MediaPlainProps> = (
  props: MediaPlainProps
) => {
  const handleClickRoot = (e: React.MouseEvent) => {
    e.stopPropagation();
    props.onClickRoot && props.onClickRoot(e);
  };

  return (
    <StyledBox className={classes.wrap} onClick={handleClickRoot}>
      <div className={classes.cover}>
        <Image src={props.cover || DEFULAT_SHADOW_COVER} aspectRatio={16 / 9} />
        {props.duration && (
          <Duration
            classes={{ root: classes.duration }}
            duration={props.duration}
          />
        )}
      </div>
    </StyledBox>
  );
};

export default MediaPlain;
